
import { useState, useEffect } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/04bffda83af79335128d062f8508dd8e/00ffee6af93b2b9ddf375fba6d320afe.jpeg"
          alt="Hydrogen Production Facility"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-32 w-full">
        <div className="flex flex-col items-start space-y-8">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-thin text-white leading-tight" style={{ fontFamily: 'Lato, sans-serif', fontWeight: 100 }}>
            CHANGING<br />
            THE<br />
            GAME
          </h1>
        </div>
      </div>
    </section>
  );
}
